import { render, staticRenderFns } from "./ServicePacket.vue?vue&type=template&id=518e62d5&scoped=true&"
import script from "./ServicePacket.vue?vue&type=script&lang=js&"
export * from "./ServicePacket.vue?vue&type=script&lang=js&"
import style0 from "./ServicePacket.vue?vue&type=style&index=0&id=518e62d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518e62d5",
  null
  
)

export default component.exports